import script from "./NewProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewProfile.vue?vue&type=script&setup=true&lang=ts"

import "./NewProfile.vue?vue&type=style&index=0&id=65a41512&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a41512"]])

export default __exports__